import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import {  HttpHeaders} from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import './login-users.ts';
import {LoginUser} from './login-users';


@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    private currentUserSubject: BehaviorSubject<LoginUser>;
    public currentUser: Observable<LoginUser>;

    constructor(private router:Router ) {
        this.currentUserSubject = new BehaviorSubject<LoginUser>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserValue(): LoginUser {
        return this.currentUserSubject.value;
    }

    login(loginUser:LoginUser) {
      if (loginUser && loginUser.token) {
        console.log(loginUser);
        localStorage.setItem('currentUser', JSON.stringify(loginUser));
        this.currentUserSubject.next(loginUser);
        this.router.navigateByUrl("/admin/dashboard/1")
      }else{
          return null;
      }
    }
    logout() {
      localStorage.removeItem('currentUser');
      this.currentUserSubject.next(null);
      window.location.replace("/")
  }
}
